<template>
    <div class="form-content-wrapper mb-0">
        <b-form-group label="Foto Pendukung">
            <div class="foto-input-wrapper">
                <div class="foto-preview-wrapper" >
                    <div class="foto-content-wrapper" v-if="dataFotoPendukung.activeFotoPendukungBase64 != null">
                        <img :src="dataFotoPendukung.activeFotoPendukungBase64" alt="Foto Identitas">
                        <div class="foto-view-wrapper">
                            <b-button @click="openModalPreview()">View</b-button>
                        </div>
                    </div>
                    <h6 v-else class="text-blue">No Photo</h6>
                </div>
                <div class="foto-action-wrapper">
                    <div class="action-browse-wrapper">
                        <b-form-file
                            v-model="dataFotoPendukung.fotoPendukung" name="fotoPendukung"
                            :state="Boolean(dataFotoPendukung.fotoPendukung)"
                            placeholder="Foto Identitas"
                            drop-placeholder="Drop file here..."
                            accept=".jpg, .png, .jpeg"
                            @input="browseFile()"
                        ></b-form-file>
                        <b-button variant="cancelBtn">
                            <i class="fa fa-upload mr-2"></i>
                            Browse
                        </b-button>
                    </div>
                    <div class="action-camera-wrapper cameraSmallWrapper">
                        <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto()">
                            <i class="fa fa-camera mr-2"></i>
                            Camera
                        </b-button>
                    </div>
                    <div class="action-reset-wrapper" v-if="dataFotoPendukung.urlFotoPendukung != null && dataFotoPendukung.activeFotoPendukungBase64 != $baseFilePath + dataFotoPendukung.urlFotoPendukung">
                        <b-button variant="cancelBtn" @click="resetFoto()">
                            <i class="fa fa-undo mr-2"></i>
                            Reset
                        </b-button>
                    </div>
                </div>
            </div>
        </b-form-group>
        <ModalWebCam @photoTaken="setResult" />
        <ModalPreview :fotoPreview="activeFotoPreview" />
    </div>
</template>

<script>
import ModalWebCam from '../webcam/ModalWebCam'
import ModalPreview from '../../components/webcam/ModalPreview'

export default {
    name: 'data-foto',
    components: {
        ModalWebCam,
        ModalPreview
    },
    data(){
        return{
            activeFotoPreview: "",
        }
    },
    props: {
        dataFotoPendukung: { type: Object, required: true },
    },
    methods: {

        ambilFoto(){
            this.$bvModal.show("modal-ambil-foto");
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            this.dataFotoPendukung.fotoPendukungBase64 = newResult
            this.dataFotoPendukung.activeFotoPendukungBase64 = newResult
        },

        resetFoto(){
            this.dataFotoPendukung.activeFotoPendukungBase64 = this.$baseFilePath + this.dataFotoPendukung.urlFotoPendukung
        },

        browseFile() {
            // Input dikosongkan (mis. form di-reset) -> tidak ada file untuk diproses
            if (!this.dataFotoPendukung.fotoPendukung) return

            this.toBase64(this.dataFotoPendukung.fotoPendukung).then(async base64 => {
                this.dataFotoPendukung.activeFotoPendukungBase64 = await this.$helper.resizeImage(base64)
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
            })
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        openModalPreview(){
            this.activeFotoPreview = this.dataFotoPendukung.activeFotoPendukungBase64
            this.$bvModal.show("modal-preview-foto")
        }

    }
}
</script>
